import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import { CounterTextarea } from "common/Forms/CounterTextarea";

export const MAX_REPLY_CHARS = 10000;

export default function RetainAnswerReplyInput({
    defaultValue,
    disabled,
    handleChange,
    label,
    helperText,
    ...props
}) {
    const [value, setValue] = useState(defaultValue || "");

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);

    useEffect(() => {
        handleChange(value);
    }, [value]);

    function onChange(event) {
        const newVal = event.target.value.trim();
        // don't allow updates that exceed MAX_REPLY_CHARS
        if (newVal.length < MAX_REPLY_CHARS) {
            setValue(event.target.value);
        }
    }

    return (
        <CounterTextarea
            label={label}
            disabled={disabled}
            autoFocus
            onChange={onChange}
            helperText={helperText}
            maxChars={MAX_REPLY_CHARS}
            value={value}
            {...props}
        />
    );
}

RetainAnswerReplyInput.propTypes = {
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    handleChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    helperText: PropTypes.string,
};

RetainAnswerReplyInput.defaultProps = {
    defaultValue: "",
    disabled: false,
    helperText: "",
};
